<script lang="ts">
  import { onMount } from "svelte"
  import { xhr, toast } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import StatementForm from "$app/Pages/Plans/Onboarding/components/StatementForm.svelte"
  import Navigation from "./Navigation.svelte"
  import { onboardingStore } from "./onboarding.svelte"
  import { appStore } from "$app/store.svelte"

  import bg from "@images/onboarding/bg-eclipse.jpg"
  import img from "@images/onboarding/blue_sky_vision.png"
  import PrevNextSkipButtons from "./components/PrevNextSkipButtons.svelte"

  let loaded = $state(false)
  let blue_sky_vision: StatementType = $state({})
  onboardingStore.completed = true

  async function getBlueSkyVision(): Promise<void> {
    try {
      const resp = await xhr.get(
        `/plan_onboarding/${appStore.plan.id}/get_statements.json?statement_type=blue_sky_vision`
      )

      blue_sky_vision = resp.data as StatementType
    } catch (e) {
      if (typeof Honeybadger.notify !== "undefined") {
        Honeybadger.notify(e)
      }
      toast("There was an error loading the Blue Sky Vision", "error")
    } finally {
      loaded = true
      return
    }
  }

  onMount(() => {
    getBlueSkyVision()
    onboardingStore.setBrowserHistory({}, "blue_sky_vision")
  })
</script>

<div class="mx-auto px-2 lg:px-6 pt-4 w-full pb-8 lg:pb-20 lg:text-left">
  <div class="px-4 w-full">
    <Navigation step="blue_sky_vision" on:updateStep />
  </div>
  <div class="px-4 w-full lg:w-1/2 xl:pr-16">
    <h2 class="mt-12 text-5xl font-bold text-left text-white">
      What Is Your Blue Sky Vision?
    </h2>

    <p class="mt-8 text-white text-lg max-w-lg">
      This is your 5-Year dream of what you want to achieve. It is typically the
      number of people your product and services have impacted.
    </p>

    <div class="mt-8 max-w-lg">
      {#if loaded}
        <StatementForm
          statement={blue_sky_vision}
          placeholder="Enter your Blue Sky Vision"
          title={`Your Blue Sky Vision`}
        />
      {/if}
    </div>

    <PrevNextSkipButtons />
  </div>
</div>
<div
  class="relative w-full hidden lg:inline lg:absolute lg:inset-y-32 lg:-mb-32 rounded-tl-lg lg:-right-0 md:w-1/3 lg:w-1/2 lg:h-full bg-lwp-light-grey bg-right-bottom bg-no-repeat bg-contain"
  style="background-image: url({bg})"
>
  <img
    src={img}
    alt="Your Profile"
    class="absolute shadow-lg rounded border border-gray-500 inset-y-4 inset-x-6 xl:-inset-x-6 w-11/12 object-fill"
  />
</div>
